// /* eslint-disable react/style-prop-object */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const MobileMenu = ({ menuItem }) => {
  const [activeMenu, setActiveMenu] = useState(false);
  const [portfolioSubMenu, setportfolioSubMenu] = useState(false);
  const [homeSubMenu, sethomeSubMenu] = useState(false);
  const navigate = useNavigate();

  return (
    <div id="mobile_menu">
      <div className="slicknav_menu">
        <a
          style={{ cursor: "pointer" }}
          onClick={() => setActiveMenu(!activeMenu)}
          className="slicknav_btn"
        >
          <span className="slicknav_nav_icon fas fa-bars"></span>
        </a>
        <nav
          className={
            activeMenu ? "slicknav_nav activeSlicknav" : "slicknav_nav"
          }
        >
          <ul>
            {menuItem.map((item, index) => (
              <React.Fragment key={index * (Math.random() * 10)}>
                <li
                  className={
                    item === "home"
                      ? "slicknav_parent"
                      : "" || item === "portfolio"
                      ? "slicknav_parent"
                      : ""
                  }
                >
                  <a
                    href={`#${item}`}
                    onClick={() => {
                      // (item === "home" || "portfolio") ? setActiveMenu(true) : setActiveMenu(!activeMenu);
                      if (item === "home") {
                        setActiveMenu(true);
                      } else if (item === "portfolio") {
                        setActiveMenu(true);
                      } else {
                        setActiveMenu(false);
                      }
                      navigate("/react-templates/raino");
                      item === "home" && sethomeSubMenu(!homeSubMenu);
                      item === "portfolio" &&
                        setportfolioSubMenu(!portfolioSubMenu);
                      // setActiveMenu(!activeMenu);
                    }}
                  >
                    {item}
                    {item === "home" ? (
                      <span className="slicknav_arrow">
                        {homeSubMenu ? "▼" : "►"}
                      </span>
                    ) : null || item === "portfolio" ? (
                      <span className="slicknav_arrow">
                        {portfolioSubMenu ? "▼" : "►"}
                      </span>
                    ) : null}
                  </a>
                  {item === "portfolio" ? (
                    <ul
                      className={
                        portfolioSubMenu
                          ? "sub-menu mobileSubMenu active"
                          : "sub-menu mobileSubMenu"
                      }
                    >
                      <li onClick={() => setActiveMenu(!activeMenu)}>
                        <Link to={"/react-templates/raino/portfolio-details"}>
                          portfolio Details
                        </Link>
                      </li>
                    </ul>
                  ) : null || item === "home" ? (
                    <ul
                      className={
                        homeSubMenu
                          ? "sub-menu mobileSubMenu active"
                          : "sub-menu mobileSubMenu"
                      }
                    >
                      <li onClick={() => setActiveMenu(!activeMenu)}>
                        <Link
                          to={"/react-templates/raino/"}
                          className="nav-link"
                        >
                          Home One
                        </Link>
                      </li>
                      <li onClick={() => setActiveMenu(!activeMenu)}>
                        <Link
                          to={"/react-templates/raino/home-two"}
                          className="nav-link"
                        >
                          Home Two
                        </Link>
                      </li>
                    </ul>
                  ) : null}
                </li>
              </React.Fragment>
            ))}
            <li></li>
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default MobileMenu;
